import { useState } from "react";
import lodashStartCase from "lodash/startCase";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import CampaignTargetCallService from "../../services/CampaignTargetCall";
import CampaignService from "../../services/Campaign";
import TextMessageService from "../../services/TextMessage";

const DeleteManualActivityModal = ({ item, fetchData }) => {
  const [open, setOpen] = useState(false);

  let deleteFunction;
  switch (item.auditable_type) {
    case "CampaignTargetEmail":
      deleteFunction = CampaignService.deleteCampaignTargetEmails;
      break;
    case "CampaignTargetCall":
      deleteFunction = CampaignTargetCallService.deleteCall;
      break;
    case "TextMessage":
      deleteFunction = TextMessageService.deleteTextMessage;
      break;
    default:
      deleteFunction = null;
  }

  const typeName = lodashStartCase(item.auditable_type);

  const handleDelete = async () => {
    try {
      await deleteFunction([item.auditable_id]);
    } catch {
      toast.error(`Failed to delete the ${typeName.toLowerCase()}`);
      return;
    }
    setOpen(false);
    fetchData();
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={`Delete ${typeName}`}
        disabled={!!item.auditable_deleted}
        onClick={() => setOpen(true)}
      >
        <Trash2 />
      </Button>
      <ConfirmDeleteDialog
        open={open}
        onOpenChange={setOpen}
        title={`Delete ${typeName}?`}
        description={`Are you sure you want to delete this ${typeName.toLowerCase()}?`}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DeleteManualActivityModal;
